import { Box, Typography, Paper } from '@mui/material';

const TestPage = () => {
  return (
    <Paper sx={{ p: 4, m: 4 }}>
      <Typography variant="h3" gutterBottom>Test Page</Typography>
      <Typography>This is a test page to verify routing.</Typography>
      <Box sx={{ mt: 2 }}>
        <pre>
          {JSON.stringify({
            pathname: window.location.pathname,
            user: localStorage.getItem('user'),
            token: localStorage.getItem('token')?.substring(0, 20) + '...'
          }, null, 2)}
        </pre>
      </Box>
    </Paper>
  );
};

export default TestPage; 